export const translationGroups = {
  Buttons: "Buttons.",
  ErrorDescriptions: "ErrorDescriptions.",
  ErrorTitles: "ErrorTitles.",
  ErrorCode: "ErrorCode.",
  Labels: "Labels.",
  MessageTitles: "MessageTitles.",
  ModalTitles: "ModalTitles.",
  NotificationMessages: "NotificationMessages.",
  NotificationTitles: "NotificationTitles.",
  Period: "Period.",
  Validations: "Validations.",
  Menus: "Menus.",
  WhoOpenAccount: "WhoOpenAccount.",
  Messages: "Messages.",
  Actions: "Actions.",
  ActionsDescriptions: "ActionsDescriptions.",
  ActionsButtons: "ActionsButtons.",
  ActionsTitle: "ActionsTitle.",
  ApplicationsLabels: "ApplicationsLabels.",
  ApplicationsDocuments: 'ApplicationsDocuments.',
  ApplicationsActions: "ApplicationsActions.",
  ApplicationState: "ApplicationState.",
  ApplicationStatus: "ApplicationStatus.",
  SanctionStatus: "SanctionStatus.",
  SanctionType: "SanctionType.",
  DocumentType: "DocumentType.",
  StepsDescription: "StepsDescription.",
  PrintLabels: "PrintLabels.",
  CountryFlags: "CountryFlags."
};

export const i18 = {
  ActionsTitle: {
    OndatoIdentification: translationGroups.ActionsTitle + "OndatoIdentification"
  },
  Actions: {
    ApplicationSigningStarted: translationGroups.Actions + "ApplicationSigningStarted",
    ApplicationSigned: translationGroups.Actions + "ApplicationSigningStarted"
  },
  ApplicationsActions: {
    AddRisk: translationGroups.ApplicationsActions + "AddRisk",
    ReviewedKyc: translationGroups.ApplicationsActions + "ReviewedKyc",
    ApproveRisks: translationGroups.ApplicationsActions + "ApproveRisks",
    RejectApplication: translationGroups.ApplicationsActions + "RejectApplication",
    ApproveBeneficiaries: translationGroups.ApplicationsActions + "ApproveBeneficiaries",
    ReviewSanction: translationGroups.ApplicationsActions + "ReviewSanction",
    ReviewedApplicationDocuments:
      translationGroups.ApplicationsActions + "ReviewedApplicationDocuments",
    RequestAdditionalDocuments:
      translationGroups.ApplicationsActions + "RequestAdditionalDocuments",
    RejectDueSanctionList: translationGroups.ApplicationsActions + "RejectDueSanctionList",
    AllSanctionsReviewed: translationGroups.ApplicationsActions + "AllSanctionsReviewed",
    UploadSignedApplication: translationGroups.ApplicationsActions + "UploadSignedApplication",
    ConfirmingUploadedAgreement:
      translationGroups.ApplicationsActions + "ConfirmingUploadedAgreement",
    RejectUploadedAgreement: translationGroups.ApplicationsActions + "RejectUploadedAgreement"
  },
  CountryFlags: {
    None: translationGroups.CountryFlags + "None",
    EuropeanUnion: translationGroups.CountryFlags + "EuropeanUnion",
    EuroZone: translationGroups.CountryFlags + "EuroZone",
    EuropeEconomicArea: translationGroups.CountryFlags + "EuropeEconomicArea",
    HighRisk: translationGroups.CountryFlags + "HighRisk",
    Offshore: translationGroups.CountryFlags + "Offshore",
    Sanctioned: translationGroups.CountryFlags + "Sanctioned"
  },
  ApplicationsDocuments: {
    AmlOfficerRequestedDocument: translationGroups.ApplicationsDocuments + "AmlOfficerRequestedDocument",
    employeeUploadedDocument: translationGroups.ApplicationsDocuments + "employeeUploadedDocument",
    PowerOfAttorney: translationGroups.ApplicationsDocuments + "PowerOfAttorney",
    Application: translationGroups.ApplicationsDocuments + "Application",
    OrganizationalChart: translationGroups.ApplicationsDocuments + "OrganizationalChart",
    ArticlesOfAssotiation: translationGroups.ApplicationsDocuments + "ArticlesOfAssotiation",
    WolfsbergQuestionnaire: translationGroups.ApplicationsDocuments + "WolfsbergQuestionnaire",
    BeneficiaryIdentification: translationGroups.ApplicationsDocuments + "BeneficiaryIdentification",
    Agreements: translationGroups.ApplicationsDocuments + "Agreements",
    OndataoldentificationDocument: translationGroups.ApplicationsDocuments + "OndataoldentificationDocument",
    SaisReport: translationGroups.ApplicationsDocuments + "SaisReport",
  },
  ApplicationsLabels: {
    ClientName: translationGroups.ApplicationsLabels + "ClientName",
    UploadDocComment: translationGroups.ApplicationsLabels + "UploadDocComment",
    CraScreenClientName: translationGroups.ApplicationsLabels + "CraScreenClientName",
    CraScreenClientCode: translationGroups.ApplicationsLabels + "CraScreenClientCode",
    CraScreenAppId: translationGroups.ApplicationsLabels + "CraScreenAppId",
    CraScreenDescription: translationGroups.ApplicationsLabels + "CraScreenDescription",
    CraScreenRiskType: translationGroups.ApplicationsLabels + "CraScreenRiskType",
    CraScreenFinalRisk: translationGroups.ApplicationsLabels + "CraScreenFinalRisk",
    CraScreenFinalRiskActual: translationGroups.ApplicationsLabels + "CraScreenFinalRiskActual",
    CraScreenRiskScore: translationGroups.ApplicationsLabels + "CraScreenRiskScore",
    CraScreenRiskScoreTotal: translationGroups.ApplicationsLabels + "CraScreenRiskScoreTotal",
    riskTypeLabel: translationGroups.ApplicationsLabels + "riskTypeLabel",
    riskIsActiveLabel: translationGroups.ApplicationsLabels + "riskIsActiveLabel",
    riskIsAutomaticLabel: translationGroups.ApplicationsLabels + "riskIsAutomaticLabel",
    countryFlagsLabel: translationGroups.ApplicationsLabels + "countryFlagsLabel",
    iso3Label: translationGroups.ApplicationsLabels + "iso3Label",
    countryTitleLabel: translationGroups.ApplicationsLabels + "countryTitleLabel",
    countryRatingLabel: translationGroups.ApplicationsLabels + "countryRatingLabel",
    RiskSettingsDescriptionCol: translationGroups.ApplicationsLabels + "RiskSettingsDescriptionCol",
    RiskSettingsTypeCol: translationGroups.ApplicationsLabels + "RiskSettingsTypeCol",
    RiskSettingsScoreCol: translationGroups.ApplicationsLabels + "RiskSettingsScoreCol",
    RiskSettingsIsActiveCol: translationGroups.ApplicationsLabels + "RiskSettingsIsActiveCol",
    RiskSettingsCreatedCol: translationGroups.ApplicationsLabels + "RiskSettingsCreatedCol",
    RiskSettingsDeletedDateCol: translationGroups.ApplicationsLabels + "RiskSettingsDeletedDateCol",
    RiskSettingsIsAutomaticCol: translationGroups.ApplicationsLabels + "RiskSettingsIsAutomaticCol",
    RiskSettingsIsActiveTrue: translationGroups.ApplicationsLabels + "RiskSettingsIsActiveTrue",
    RiskSettingsIsAutomaticTrue:
      translationGroups.ApplicationsLabels + "RiskSettingsIsAutomaticTrue",
    RiskSettingsIsAutomaticFalse:
      translationGroups.ApplicationsLabels + "RiskSettingsIsAutomaticFalse",
    RiskSettingsIsActiveFalse: translationGroups.ApplicationsLabels + "RiskSettingsIsActiveFalse",
    isActualFilterInput: translationGroups.ApplicationsLabels + "isActualFilterInput",
    WithHistoryFilterInput: translationGroups.ApplicationsLabels + "WithHistoryFilterInput",
    iso2FilterInput: translationGroups.ApplicationsLabels + "iso2FilterInput",
    NaceBlockersSettings: translationGroups.ApplicationsLabels + "NaceBlockersSettings",
    NaceBlockersTitleCol: translationGroups.ApplicationsLabels + "NaceBlockersTitleCol",
    NaceBlockersCodeCol: translationGroups.ApplicationsLabels + "NaceBlockersCodeCol",
    NaceBlockersIsActualCol: translationGroups.ApplicationsLabels + "NaceBlockersIsActualCol",
    NaceBlockersIsActualTrue: translationGroups.ApplicationsLabels + "NaceBlockersIsActualTrue",
    NaceBlockersIsActualFalse: translationGroups.ApplicationsLabels + "NaceBlockersIsActualFalse",
    NaceBlockersCreatedCol: translationGroups.ApplicationsLabels + "NaceBlockersCreatedCol",
    NaceBlockersDeletedDateCol: translationGroups.ApplicationsLabels + "NaceBlockersDeletedDateCol",
    NaceBlockerTitleInput: translationGroups.ApplicationsLabels + "NaceBlockerTitleInput",
    NaceBlockersCodeInput: translationGroups.ApplicationsLabels + "NaceBlockersCodeInput",
    CountrySettingsTableisActiveFalse:
      translationGroups.ApplicationsLabels + "CountrySettingsTableisActiveFalse",
    CountrySettingsTableisActiveTrue:
      translationGroups.ApplicationsLabels + "CountrySettingsTableisActiveTrue",
    CountryFlagNoneCol: translationGroups.ApplicationsLabels + "CountryFlagNoneCol",
    CountryFlagHighRiskCol: translationGroups.ApplicationsLabels + "CountryFlagHighRiskCol",
    CountryFlagOffShoreCol: translationGroups.ApplicationsLabels + "CountryFlagOffShoreCol",
    CountryFlagSanctionedCol: translationGroups.ApplicationsLabels + "CountryFlagSanctionedCol",
    CountryFlagEuroZoneCol: translationGroups.ApplicationsLabels + "CountryFlagEuroZoneCol",
    CountryFlagIsActiveTrue: translationGroups.ApplicationsLabels + "CountryFlagIsActiveTrue",
    CountryFlagIsActiveFalse: translationGroups.ApplicationsLabels + "CountryFlagIsActiveFalse",
    CountryFlagEuroEconomicAreaCol:
      translationGroups.ApplicationsLabels + "CountryFlagEuroEconomicAreaCol",
    CountryFlagEuropeanUnionCol:
      translationGroups.ApplicationsLabels + "CountryFlagEuropeanUnionCol",
    CountrySettingsTableisActualTrue:
      translationGroups.ApplicationsLabels + "CountrySettingsTableisActualTrue",
    CountrySettingsTableisActualFalse:
      translationGroups.ApplicationsLabels + "CountrySettingsTableisActualFalse",
    CountrySettings: translationGroups.ApplicationsLabels + "CountrySettings",
    CountrySettingsTableTitleCol:
      translationGroups.ApplicationsLabels + "CountrySettingsTableTitleCol",
    CountrySettingsTableOs2Col: translationGroups.ApplicationsLabels + "CountrySettingsTableOs2Col",
    CountrySettingsTableOs3Col: translationGroups.ApplicationsLabels + "CountrySettingsTableOs3Col",
    CountrySettingsTableCreatedCol:
      translationGroups.ApplicationsLabels + "CountrySettingsTableCreatedCol",
    CountrySettingsTableDeletedCol:
      translationGroups.ApplicationsLabels + "CountrySettingsTableDeletedCol",
    CountrySettingsTableisActualCol:
      translationGroups.ApplicationsLabels + "CountrySettingsTableisActualCol",
    CountrySettingsTableRatingCol:
      translationGroups.ApplicationsLabels + "CountrySettingsTableRatingCol",
    RiskSettings: translationGroups.ApplicationsLabels + "RiskSettings",
    LowRisk: translationGroups.ApplicationsLabels + "LowRisk",
    MediumRisk: translationGroups.ApplicationsLabels + "MediumRisk",
    HighRisk: translationGroups.ApplicationsLabels + "HighRisk",
    UnacceptableRisk: translationGroups.ApplicationsLabels + "UnacceptableRisk",
    HighRiskBusinessActivityStopper:
      translationGroups.ApplicationsLabels + "HighRiskBusinessActivityStopper",
    OwnershipStructureRisk: translationGroups.ApplicationsLabels + "OwnershipStructureRisk",
    OtherRisk: translationGroups.ApplicationsLabels + "OtherRisk",
    CustomerRiskFactors: translationGroups.ApplicationsLabels + "CustomerRiskFactors",
    DeliveryChannelRisk: translationGroups.ApplicationsLabels + "DeliveryChannelRisk",
    CountryRiskFactors: translationGroups.ApplicationsLabels + "CountryRiskFactors",
    ProductsRiskFactors: translationGroups.ApplicationsLabels + "ProductsRiskFactors",
    TransactionRiskFactors: translationGroups.ApplicationsLabels + "TransactionRiskFactors",
    DocAndCommentRequired: translationGroups.ApplicationsLabels + "DocAndCommentRequired",
    DocRequiredCommentNot: translationGroups.ApplicationsLabels + "DocRequiredCommentNot",
    CommentRequiredDocNot: translationGroups.ApplicationsLabels + "DocRequiredCommentNot",
    Created: translationGroups.ApplicationsLabels + "Created",
    changeFinalRisk: translationGroups.ApplicationsLabels + "changeFinalRisk",
    NeedUserAction: translationGroups.ApplicationsLabels + "NeedUserAction",
    NeedsEmployeeAction: translationGroups.ApplicationsLabels + "NeedsEmployeeAction",
    State: translationGroups.ApplicationsLabels + "State",
    Status: translationGroups.ApplicationsLabels + "Status",
    ApplicationNumber: translationGroups.ApplicationsLabels + "ApplicationNumber",
    ClientCode: translationGroups.ApplicationsLabels + "ClientCode",
    Name: translationGroups.ApplicationsLabels + "Name",
    Type: translationGroups.ApplicationsLabels + "Type",
    Comment: translationGroups.ApplicationsLabels + "Comment",
    RiskDescription: translationGroups.ApplicationsLabels + "RiskDescription",
    Description: translationGroups.ApplicationsLabels + "Description",
    Matched: translationGroups.ApplicationsLabels + "Matched",
    CheckSanctions: translationGroups.ApplicationsLabels + "CheckSanctions",
    Application: translationGroups.ApplicationsLabels + "Application",
    CheckDocument: translationGroups.ApplicationsLabels + "CheckDocument",
    Documents: translationGroups.ApplicationsLabels + "Documents",
    FileName: translationGroups.ApplicationsLabels + "FileName",
    Datetime: translationGroups.ApplicationsLabels + "Datetime",
    DocumentType: translationGroups.ApplicationsLabels + "DocumentType",
    ApplicationDetails: translationGroups.ApplicationsLabels + "ApplicationDetails",
    RisksScore: translationGroups.ApplicationsLabels + "RisksScore",
    TotalScore: translationGroups.ApplicationsLabels + "TotalScore",
    RiskScore: translationGroups.ApplicationsLabels + "RiskScore",
    RiskComment: translationGroups.ApplicationsLabels + "RiskComment",
    DocumentClientComment: translationGroups.ApplicationsLabels + "DocumentClientComment",
    AreYouSure: translationGroups.ApplicationsLabels + "AreYouSure",
    Share: translationGroups.ApplicationsLabels + "Share",
    Remove: translationGroups.ApplicationsLabels + "Remove",
    AddOwner: translationGroups.ApplicationsLabels + "AddOwner",
    Cancel: translationGroups.ApplicationsLabels + "Cancel",
    Company: translationGroups.ApplicationsLabels + "Company",
    Person: translationGroups.ApplicationsLabels + "Person",
    ProcessType: translationGroups.ApplicationsLabels + "ProcessType",
    UploadOrgStructure: translationGroups.ApplicationsLabels + "UploadOrgStructure",
    AddOrgStructure: translationGroups.ApplicationsLabels + "AddOrgStructure",
    NeedActionFromEmployee: translationGroups.ApplicationsLabels + "NeedActionFromEmployee",
    CheckDocumentName: translationGroups.ApplicationsLabels + "CheckDocumentName",
    CheckDocumentNeedWorkComment:
      translationGroups.ApplicationsLabels + "CheckDocumentNeedWorkComment",
    CheckDocumentMissingDocComment:
      translationGroups.ApplicationsLabels + "CheckDocumentMissingDocComment",
    CheckDocumentMissingDocType:
      translationGroups.ApplicationsLabels + "CheckDocumentMissingDocType",
    CheckDocumentSelectMandatoryOptions:
      translationGroups.ApplicationsLabels + "CheckDocumentSelectMandatoryOptions",
    FileWithMandatoryComment: translationGroups.ApplicationsLabels + "FileWithMandatoryComment",
    FileWithoutComment: translationGroups.ApplicationsLabels + "FileWithoutComment",
    FileWithOptionalComment: translationGroups.ApplicationsLabels + "FileWithOptionalComment",
    OptionalFileMandatoryComment:
      translationGroups.ApplicationsLabels + "OptionalFileMandatoryComment",
    MandatoryComment: translationGroups.ApplicationsLabels + "MandatoryComment"
  },
  Buttons: {
    Submit: translationGroups.Buttons + "Submit",
    GetAllClientRisksScreen: translationGroups.Buttons + "GetAllClientRisksScreen",
    GetExcelRisksScreen: translationGroups.Buttons + "GetExcelRisksScreen",
    MarkIdStart: translationGroups.Buttons + "MarkIdStart",
    Approve: translationGroups.Buttons + "Approve",
    AddRisk: translationGroups.Buttons + "AddRisk",
    AddManualRisks: translationGroups.Buttons + "AddManualRisks",
    Delete: translationGroups.Buttons + "Delete",
    Edit: translationGroups.Buttons + "Edit",
    OndatoStart: translationGroups.Buttons + "OndatoStart",
    Reset: translationGroups.Buttons + "Reset",
    PrevStep: translationGroups.Buttons + "PrevStep",
    NextStep: translationGroups.Buttons + "NextStep",
    DuplicateBlocks: translationGroups.Buttons + "DuplicateBlocks",
    RemoveBlocks: translationGroups.Buttons + "RemoveBlocks",
    SignIn: translationGroups.Buttons + "SignIn",
    Logout: translationGroups.Buttons + "Logout",
    CheckState: translationGroups.Buttons + "CheckState",
    IdentificationRedirect: translationGroups.Buttons + "IdentificationRedirect",
    ReviewSanction: translationGroups.Buttons + "ReviewSanction",
    SanctionReviewed: translationGroups.Buttons + "SanctionReviewed",
    Upload: translationGroups.Buttons + "Upload",
    CloseModal: translationGroups.Buttons + "CloseModal",
    RejectApplication: translationGroups.Buttons + "RejectApplication",
    RequestAdditionalDocuments: translationGroups.Buttons + "RequestAdditionalDocuments",
    ApproveRisk: translationGroups.Buttons + "ApproveRisk",
    RejectDueSanctionList: translationGroups.Buttons + "RejectDueSanctionList",
    PreSignIn: translationGroups.Buttons + "PreSignIn",
    ToSignIn: translationGroups.Buttons + "ToSignIn",
    Ok: translationGroups.Buttons + "Ok",
    Cancel: translationGroups.Buttons + "Cancel",
    ShowApplicationDocument: translationGroups.Buttons + "ShowApplicationDocument",
    OndatoIdentification: translationGroups.Buttons + "OndatoIdentification",
    ApproveBeneficiaries: translationGroups.Buttons + "ApproveBeneficiaries",
    ConfirmUploadAgreement: translationGroups.Buttons + "ConfirmUploadAgreement",
    Add: translationGroups.Buttons + "Add",
    Save: translationGroups.Buttons + "Save",
    Print: translationGroups.Buttons + "Print",
    Filter: translationGroups.Buttons + "Filter",
    KycDocumentApprove: translationGroups.Buttons + "KycDocumentApprove",
    KycDocumentNeedWork: translationGroups.Buttons + "KycDocumentNeedWork",
    ProvideAuthTemplate: translationGroups.Buttons + "ProvideAuthTemplate",
    DownloadPDF: translationGroups.Buttons + "DownloadPDF"
  },
  ErrorDescriptions: {
    JSONBreaks: translationGroups.ErrorTitles + "JSONBreaks"
  },
  ErrorTitles: {
    KycError: translationGroups.ErrorTitles + "KycError",
    JSONBreaks: translationGroups.ErrorTitles + "JSONBreaks"
  },
  Labels: {
    ControlCodeTimeLeft: translationGroups.Labels + "ControlCodeTimeLeft",
    SmartId: translationGroups.Labels + "SmartId",
    Mobile: translationGroups.Labels + "Mobile",
    BioFace: translationGroups.Labels + "BioFace",
    CompanyCode: translationGroups.Labels + "CompanyCode",
    CompanyState: translationGroups.Labels + "CompanyState",
    CompanyStatus: translationGroups.Labels + "CompanyStatus",
    WaitingRoomSomethingWrong: translationGroups.Labels + "WaitingRoomSomethingWrong",
    TotalScore: translationGroups.Labels + "TotalScore",
    SelectDocType: translationGroups.Labels + "SelectDocType",
    RiskModalValidationErrors: translationGroups.Labels + "RiskModalValidationErrors",
    RiskModalEmptyInputError: translationGroups.Labels + "RiskModalEmptyInputError",
    NoAuthorizedCompany: translationGroups.Labels + "NoAuthorizedCompany",
    Account: translationGroups.Labels + "Account",
    WrongShare: translationGroups.Labels + "WrongShare",
    AccountNumber: translationGroups.Labels + "AccountNumber",
    Actions: translationGroups.Labels + "Actions",
    AdditionalInformation: translationGroups.Labels + "AdditionalInformation",
    AdditionalPaymentInformation: translationGroups.Labels + "AdditionalPaymentInformation",
    AgreeWithTerms: translationGroups.Labels + "AgreeWithTerms",
    Amount: translationGroups.Labels + "Amount",
    AutoRenewDeposit: translationGroups.Labels + "AutoRenewDeposit",
    BankText: translationGroups.Labels + "BankText",
    NoBankText: translationGroups.Labels + "NoBankText",
    BackToGroupList: translationGroups.Labels + "BackToGroupList",
    BlocksPayment: translationGroups.Labels + "BlocksPayment",
    ChoosePersonOrCompany: translationGroups.Labels + "ChoosePersonOrCompany",
    CreditCardToBlock: translationGroups.Labels + "CreditCardToBlock",
    Currency: translationGroups.Labels + "Currency",
    ControlCode: translationGroups.Labels + "ControlCode",
    Commission: translationGroups.Labels + "Commission",
    Date: translationGroups.Labels + "Date",
    DateFrom: translationGroups.Labels + "DateFrom",
    DateTo: translationGroups.Labels + "DateTo",
    DepositType: translationGroups.Labels + "DepositType",
    DestinationsCode: translationGroups.Labels + "DestinationsCode",
    ExistingGroup: translationGroups.Labels + "ExistingGroup",
    ExpenditureRevenue: translationGroups.Labels + "ExpenditureRevenue",
    FirstLogin: translationGroups.Labels + "FirstLogin",
    Fee: translationGroups.Labels + "Fee",
    FeeCode: translationGroups.Labels + "FeeCode",
    FeeCurrency: translationGroups.Labels + "FeeCurrency",
    FeeProvider: translationGroups.Labels + "FeeProvider",
    FromAccount: translationGroups.Labels + "FromAccount",
    FinalPayeeTitle: translationGroups.Labels + "FinalPayeeTitle",
    FinalPayeeType: translationGroups.Labels + "FinalPayeeType",
    FinalPayeeName: translationGroups.Labels + "FinalPayeeName",
    FinalPayeeIdentTypeCode: translationGroups.Labels + "FinalPayeeIdentTypeCode",
    FinalPayeeIdentTypeValue: translationGroups.Labels + "FinalPayeeIdentTypeValue",
    IdentificationCode: translationGroups.Labels + "IdentificationCode",
    IdentificationSMSCode: translationGroups.Labels + "IdentificationSMSCode",
    IdentificationType: translationGroups.Labels + "IdentificationType",
    IdentificationUID: translationGroups.Labels + "IdentificationUID",
    Information: translationGroups.Labels + "Information",
    Interest: translationGroups.Labels + "Interest",
    InterestPay: translationGroups.Labels + "InterestPay",
    InitPayerCode: translationGroups.Labels + "InitPayerCode",
    InitPayerType: translationGroups.Labels + "InitPayerType",
    InitPayerTitle: translationGroups.Labels + "InitPayerTitle",
    InitPayerIdentTypeCode: translationGroups.Labels + "InitPayerIdentTypeCode",
    InitPayerIdentTypeValue: translationGroups.Labels + "InitPayerIdentTypeValue",
    Loading: translationGroups.Labels + "Loading",
    OperationLimit: translationGroups.Labels + "OperationLimit",
    OperationDayLimit: translationGroups.Labels + "OperationDayLimit",
    OperationMonthLimit: translationGroups.Labels + "OperationMonthLimit",
    Payer: translationGroups.Labels + "Payer",
    PayerAccountNumber: translationGroups.Labels + "PayerAccountNumber",
    PayerAddress: translationGroups.Labels + "PayerAddress",
    PayerBank: translationGroups.Labels + "PayerBank",
    PayerIdentityCode: translationGroups.Labels + "PayerIdentityCode",
    PayerIdentityType: translationGroups.Labels + "PayerIdentityType",
    PayerPayeePurpose: translationGroups.Labels + "PayerPayeePurpose",
    PayerTitle: translationGroups.Labels + "PayerTitle",
    PayerType: translationGroups.Labels + "PayerType",
    PaymentGroups: translationGroups.Labels + "PaymentGroups",
    Phone: translationGroups.Labels + "Phone",
    PhoneNumber: translationGroups.Labels + "PhoneNumber",
    Purpose: translationGroups.Labels + "Purpose",
    MonthNameShort: translationGroups.Labels + "MonthNameShort",
    NewGroup: translationGroups.Labels + "NewGroup",
    Note: translationGroups.Labels + "Note",
    Payee: translationGroups.Labels + "Payee",
    PayeeAccount: translationGroups.Labels + "PayeeAccount",
    PayeeAccountNumber: translationGroups.Labels + "PayeeAccountNumber",
    PayeeAddress: translationGroups.Labels + "PayeeAddress",
    PayeeBank: translationGroups.Labels + "PayeeBank",
    PayeeIdentityCode: translationGroups.Labels + "PayeeIdentityCode",
    PayeeIdentityType: translationGroups.Labels + "PayeeIdentityType",
    PayeeTitle: translationGroups.Labels + "PayeeTitle",
    PayeeType: translationGroups.Labels + "PayeeType",
    PaymentDescription: translationGroups.Labels + "PaymentDescription",
    PaymentTemplateDescription: translationGroups.Labels + "PaymentTemplateDescription",
    PaymentTemplates: translationGroups.Labels + "PaymentTemplates",
    PaymentTemplateName: translationGroups.Labels + "PaymentTemplateName",
    PaymentGroupReceivers: translationGroups.Labels + "PaymentGroupReceivers",
    PaymentType: translationGroups.Labels + "PaymentType",
    Payments: translationGroups.Labels + "Payments",
    PaymentUniqueCode: translationGroups.Labels + "PaymentUniqueCode",
    Password: translationGroups.Labels + "Password",
    PasswordCurrent: translationGroups.Labels + "PasswordCurrent",
    PasswordNew: translationGroups.Labels + "PasswordNew",
    PasswordNewRepeat: translationGroups.Labels + "PasswordNewRepeat",
    Period: translationGroups.Labels + "Period",
    PurposeType: translationGroups.Labels + "PurposeType",
    RecipientBankName: translationGroups.Labels + "RecipientBankName",
    SavePaymentTemplate: translationGroups.Labels + "SavePaymentTemplate",
    SaveToSignSuccesseful: translationGroups.Labels + "SaveToSignSuccesseful",
    SelectFile: translationGroups.Labels + "SelectFile",
    SenderData: translationGroups.Labels + "SenderData",
    Summary: translationGroups.Labels + "Summary",
    ReceivedData: translationGroups.Labels + "ReceivedData",
    Term: translationGroups.Labels + "Term",
    Title: translationGroups.Labels + "Title",
    Template: translationGroups.Labels + "Template",
    ToAccount: translationGroups.Labels + "ToAccount",
    UploadDateTime: translationGroups.Labels + "UploadDateTime",
    FileName: translationGroups.Labels + "FileName",
    PaymentCount: translationGroups.Labels + "PaymentCount",
    PaymentSum: translationGroups.Labels + "PaymentSum",
    OperationRejectedSevenDays: translationGroups.Labels + "OperationRejectedSevenDays",
    unreadMessages: translationGroups.Labels + "unreadMessages",
    Message: translationGroups.Labels + "Message",
    ClientName: translationGroups.Labels + "ClientName",
    ClientTitle: translationGroups.Labels + "ClientTitle",
    ClientId: translationGroups.Labels + "ClientId",
    ClientRegCountry: translationGroups.Labels + "ClientRegCountry",
    ClientDocsType: translationGroups.Labels + "ClientDocsType",
    ClientDocNo: translationGroups.Labels + "ClientDocNo",
    ClientDocCountry: translationGroups.Labels + "ClientDocCountry",
    ClientDocIssuePlace: translationGroups.Labels + "ClientDocIssuePlace",
    ClientDocIssueDate: translationGroups.Labels + "ClientDocIssueDate",
    ClientDocValidDate: translationGroups.Labels + "ClientDocValidDate",
    AddressType: translationGroups.Labels + "AddressType",
    AddressCountry: translationGroups.Labels + "AddressCountry",
    AddressMunicipality: translationGroups.Labels + "AddressMunicipality",
    AddressCity: translationGroups.Labels + "AddressCity",
    AddressStreet: translationGroups.Labels + "AddressStreet",
    AddressHouse: translationGroups.Labels + "AddressHouse",
    AddressFlat: translationGroups.Labels + "AddressFlat",
    AddressPostCode: translationGroups.Labels + "AddressPostCode",
    ClientPhoneType: translationGroups.Labels + "ClientPhoneType",
    ClientPhoneNo: translationGroups.Labels + "ClientPhoneNo",
    ClientTaxPayerLt: translationGroups.Labels + "ClientTaxPayerLt",
    ClientIncomeSource: translationGroups.Labels + "ClientIncomeSource",
    ClientIncomeSalary: translationGroups.Labels + "ClientIncomeSalary",
    ClientIncomeRe: translationGroups.Labels + "ClientIncomeRe",
    ClientIncomeIdv: translationGroups.Labels + "ClientIncomeIdv",
    ClientIncomeStip: translationGroups.Labels + "ClientIncomeStip",
    ClientIncomeStock: translationGroups.Labels + "ClientIncomeStock",
    ClientIncomeBenef: translationGroups.Labels + "ClientIncomeBenef",
    ClientIncomeSav: translationGroups.Labels + "ClientIncomeSav",
    ClientIncomeOtherT: translationGroups.Labels + "ClientIncomeOtherT",
    ClientMonthIncome: translationGroups.Labels + "ClientMonthIncome",
    ClientPoliticsMember: translationGroups.Labels + "ClientPoliticsMember",
    ClientPoliticsMinist: translationGroups.Labels + "ClientPoliticsMinist",
    ClientPoliticsParl: translationGroups.Labels + "ClientPoliticsParl",
    ClientPoliticsJutge: translationGroups.Labels + "ClientPoliticsJutge",
    ClientPoliticsMay: translationGroups.Labels + "ClientPoliticsMay",
    ClientPoliticsAudit: translationGroups.Labels + "ClientPoliticsAudit",
    ClientPoliticsAmb: translationGroups.Labels + "ClientPoliticsAmb",
    ClientPoliticsJoint: translationGroups.Labels + "ClientPoliticsJoint",
    ClientPoliticsMJoint: translationGroups.Labels + "ClientPoliticsMJoint",
    clientPoliticsInternOrg: translationGroups.Labels + "clientPoliticsInternOrg",
    ClientPoliticsPolPart: translationGroups.Labels + "ClientPoliticsPolPart",
    ClientPoliticsList: translationGroups.Labels + "ClientPoliticsList",
    ClientPoliticsName: translationGroups.Labels + "ClientPoliticsName",
    ClientPoliticsCountry: translationGroups.Labels + "ClientPoliticsCountry",
    ClientPoliticsLink: translationGroups.Labels + "ClientPoliticsLink",
    ClientEmpComp: translationGroups.Labels + "ClientEmpComp",
    ClientEmpCompType: translationGroups.Labels + "ClientEmpCompType",
    ClientEmpCompName: translationGroups.Labels + "ClientEmpCompName",
    ClientEmpCompCountry: translationGroups.Labels + "ClientEmpCompCountry",
    ClientEmpPosition: translationGroups.Labels + "ClientEmpPosition",
    ClientPcComp: translationGroups.Labels + "ClientPcComp",
    ClientPcType: translationGroups.Labels + "ClientPcType",
    ClientPcCompBusiness: translationGroups.Labels + "ClientPcCompBusiness",
    ClientPension: translationGroups.Labels + "ClientPension",
    ClientStudent: translationGroups.Labels + "ClientStudent",
    ClientFarmer: translationGroups.Labels + "ClientFarmer",
    ClientNonEmp: translationGroups.Labels + "ClientNonEmp",
    ClientEmail: translationGroups.Labels + "ClientEmail",
    ClientAddress: translationGroups.Labels + "ClientAddress",
    OtherClientAddress: translationGroups.Labels + "OtherClientAddress",
    ClientPhone: translationGroups.Labels + "ClientPhone",
    OtherClientPhone: translationGroups.Labels + "OtherClientPhone",
    IncomePerMonth: translationGroups.Labels + "IncomePerMonth",
    ClientEmployment: translationGroups.Labels + "ClientEmployment",
    ClientOther: translationGroups.Labels + "ClientOther",
    KycUpdating: translationGroups.Labels + "KycUpdating",
    KycMustUpdated: translationGroups.Labels + "KycMustUpdated",
    KycNeedUpdated: translationGroups.Labels + "KycNeedUpdated",
    True: translationGroups.Labels + "True",
    False: translationGroups.Labels + "False",
    Yes: translationGroups.Labels + "Yes",
    No: translationGroups.Labels + "No",
    ClientPoliticsMemberFirstNote: translationGroups.Labels + "ClientPoliticsMemberFirstNote",
    ClientPoliticsMemberSecondNote: translationGroups.Labels + "ClientPoliticsMemberSecondNote",
    ClientPlanCashTurn: translationGroups.Labels + "ClientPlanCashTurn",
    clientAccountBank: translationGroups.Labels + "clientAccountBank",
    clientAccountBankName: translationGroups.Labels + "clientAccountBankName",
    clientAccountBankCountry: translationGroups.Labels + "clientAccountBankCountry",
    InformationAboutClient: translationGroups.Labels + "InformationAboutClient",
    ClientFullName: translationGroups.Labels + "ClientFullName",
    ClientBirthDate: translationGroups.Labels + "ClientBirthDate",
    ClientVatCode: translationGroups.Labels + "ClientVatCode",
    ClientEmployeeQty: translationGroups.Labels + "ClientEmployeeQty",
    ClientCeo: translationGroups.Labels + "ClientCeo",
    ClientCeoName: translationGroups.Labels + "ClientCeoName",
    ClientCeoSurname: translationGroups.Labels + "ClientCeoSurname",
    ClientCeoId: translationGroups.Labels + "ClientCeoId",
    ClientCeoCitizien: translationGroups.Labels + "ClientCeoCitizien",
    ClientCeoPhoneNo: translationGroups.Labels + "ClientCeoPhoneNo",
    ClientCeoIdDocType: translationGroups.Labels + "ClientCeoIdDocType",
    ClientCeoDocNo: translationGroups.Labels + "ClientCeoDocNo",
    ClientCeoDocIssueDate: translationGroups.Labels + "ClientCeoDocIssueDate",
    ClientCeoDocValidDate: translationGroups.Labels + "ClientCeoDocValidDate",
    ClientCeoDocCountry: translationGroups.Labels + "ClientCeoDocCountry",
    ClientRepName: translationGroups.Labels + "ClientRepName",
    ClientRepSurname: translationGroups.Labels + "ClientRepSurname",
    ClientRepId: translationGroups.Labels + "ClientRepId",
    ClientRepMandatValidDate: translationGroups.Labels + "ClientRepMandatValidDate",
    ClientRepRegCountry: translationGroups.Labels + "ClientRepRegCountry",
    ClientRepPhoneNo: translationGroups.Labels + "ClientRepPhoneNo",
    ClientRepIdDocType: translationGroups.Labels + "ClientRepIdDocType",
    ClientRepDocNo: translationGroups.Labels + "ClientRepDocNo",
    ClientRepDocCountry: translationGroups.Labels + "ClientRepDocCountry",
    ClientBasicBusiness: translationGroups.Labels + "ClientBasicBusiness",
    ClientBasicBusinessGroup: translationGroups.Labels + "ClientBasicBusinessGroup",
    ClientBasicBusinessSubGroups: translationGroups.Labels + "ClientBasicBusinessSubGroups",
    ClientBasicBusinessType: translationGroups.Labels + "ClientBasicBusinessType",
    ClientBasicRegion: translationGroups.Labels + "ClientBasicRegion",
    ClientBasicRegionType: translationGroups.Labels + "ClientBasicRegionType",
    ClientBusPartner: translationGroups.Labels + "ClientBusPartner",
    ClientBusPartnerType: translationGroups.Labels + "ClientBusPartnerType",
    ClientBusPartnerName: translationGroups.Labels + "ClientBusPartnerName",
    ClientBusPartnerCountry: translationGroups.Labels + "ClientBusPartnerCountry",
    ClientPlanTurn: translationGroups.Labels + "ClientPlanTurn",
    ClientTax: translationGroups.Labels + "ClientTax",
    ClientTaxPayerType: translationGroups.Labels + "ClientTaxPayerType",
    ClientTaxPayerCountry: translationGroups.Labels + "ClientTaxPayerCountry",
    ClientTaxPayerId: translationGroups.Labels + "ClientTaxPayerId",
    ClientTaxPayerHid: translationGroups.Labels + "ClientTaxPayerHid",
    ClientAccountBank: translationGroups.Labels + "ClientAccountBank",
    ClientAccountBankName: translationGroups.Labels + "ClientAccountBankName",
    ClientAccountBankCountry: translationGroups.Labels + "ClientAccountBankCountry",
    ClientBeneficiaries: translationGroups.Labels + "ClientBeneficiaries",
    ClientBenefType: translationGroups.Labels + "ClientBenefType",
    ClientBenefName: translationGroups.Labels + "ClientBenefName",
    ClientBenefSurname: translationGroups.Labels + "ClientBenefSurname",
    ClientBenefBirthCountry: translationGroups.Labels + "ClientBenefBirthCountry",
    ClientBenefRegCountry: translationGroups.Labels + "ClientBenefRegCountry",
    ClientBenefCountry: translationGroups.Labels + "ClientBenefCountry",
    ClientBenefAddress: translationGroups.Labels + "ClientBenefAddress",
    ClientBenefTaxCountry: translationGroups.Labels + "ClientBenefTaxCountry",
    ClientBenefTaxId: translationGroups.Labels + "ClientBenefTaxId",
    ClientBenefShare: translationGroups.Labels + "ClientBenefShare",
    TaxTrue: translationGroups.Labels + "TaxTrue",
    TaxFalse: translationGroups.Labels + "TaxFalse",
    ClientRep: translationGroups.Labels + "ClientRep",
    ClientBeneficiariesNote: translationGroups.Labels + "ClientBeneficiariesNote",
    Reservations: translationGroups.Labels + "Reservations",
    OtherActivity: translationGroups.Labels + "OtherActivity",
    ClientCivilServant: translationGroups.Labels + "ClientCivilServant",
    DateDisplay: translationGroups.Labels + "DateDisplay",
    LoanAmount: translationGroups.Labels + "LoanAmount",
    InterestAmount: translationGroups.Labels + "InterestAmount",
    Installment: translationGroups.Labels + "Installment",
    LoanResidual: translationGroups.Labels + "LoanResidual",
    LoanScheduleNote: translationGroups.Labels + "LoanScheduleNote",
    ClientBenefNera: translationGroups.Labels + "ClientBenefNera",
    ClientBenefReason: translationGroups.Labels + "ClientBenefReason",
    ClientStructure: translationGroups.Labels + "ClientStructure",
    ExplainAboutStructure: translationGroups.Labels + "ExplainAboutStructure",
    ClientOrgStructureDesc: translationGroups.Labels + "ClientOrgStructureDesc",
    ClientOrgStructureDirect: translationGroups.Labels + "ClientOrgStructureDirect",
    ClientTaxPayerOther: translationGroups.Labels + "ClientTaxPayerOther",
    InfomationAboutTaxesInOtherCountry:
      translationGroups.Labels + "InfomationAboutTaxesInOtherCountry",
    ClientTaxPayerConfirm: translationGroups.Labels + "СlientTaxPayerConfirm",
    TaxInformationFirstNote: translationGroups.Labels + "TaxInformationFirstNote",
    ClientBeneficiaryConf: translationGroups.Labels + "ClientBeneficiaryConf",
    ClientEmailType: translationGroups.Labels + "ClientEmailType",
    ClientDocuments: translationGroups.Labels + "ClientDocuments",
    ClientPlanTurnover: translationGroups.Labels + "ClientPlanTurnover",
    ClientPlanCashTurnover: translationGroups.Labels + "ClientPlanCashTurnover",
    ClientFundsRec: translationGroups.Labels + "ClientFundsRec",
    ClientFundsRecCountryType: translationGroups.Labels + "ClientFundsRecCountryType",
    ClientFundsRecCountry: translationGroups.Labels + "ClientFundsRecCountry",
    ClientFundsSent: translationGroups.Labels + "ClientFundsSent",
    ClientFundsSentCountry: translationGroups.Labels + "ClientFundsSentCountry",
    ClientProfile: translationGroups.Labels + "ClientProfile",
    PersonalCode: translationGroups.Labels + "PersonalCode",
    ProviderStatus: translationGroups.Labels + "ProviderStatus",
    SentToCore: translationGroups.Labels + "SentToCore",
    CoreStatus: translationGroups.Labels + "CoreStatus",
    CoreError: translationGroups.Labels + "CoreError",
    CompanyName: translationGroups.Labels + "CompanyName",
    WithDeleted: translationGroups.Labels + "WithDeleted",
    ClientContacts: translationGroups.Labels + "ClientContacts",
    ClientLegalStatus: translationGroups.Labels + "ClientLegalStatus",
    ClientSize: translationGroups.Labels + "ClientSize",
    DirectMarketing: translationGroups.Labels + "DirectMarketing",
    ClientChannel: translationGroups.Labels + "ClientChannel",
    ClientManager: translationGroups.Labels + "ClientManager",
    ClientAdditionalInformation: translationGroups.Labels + "ClientAdditionalInformation",
    InsSect: translationGroups.Labels + "InsSect",
    BalAsst: translationGroups.Labels + "BalAsst",
    ClientWeb: translationGroups.Labels + "ClientWeb",
    ClientRepPosition: translationGroups.Labels + "ClientRepPosition",
    QuestStoreDate: translationGroups.Labels + "QuestStoreDate",
    OrgStructure: translationGroups.Labels + "OrgStructure",
    Regulatons: translationGroups.Labels + "Regulatons",
    RcList: translationGroups.Labels + "RcList",
    FooterCopyright: translationGroups.Labels + "FooterCopyright",
    FinRaport: translationGroups.Labels + "FinRaport",
    CeoId: translationGroups.Labels + "CeoId",
    CeoDocument: translationGroups.Labels + "CeoDocument",
    BenefDocuments: translationGroups.Labels + "BenefDocuments",
    OtherDoc: translationGroups.Labels + "OtherDoc",
    ClientManagment: translationGroups.Labels + "ClientManagment",
    ClientCeoCountry: translationGroups.Labels + "ClientCeoCountry",
    ClientCeoDocIssuePlace: translationGroups.Labels + "ClientCeoDocIssuePlace",
    ClientCeoProfile: translationGroups.Labels + "ClientCeoProfile",
    ClientCeoDocument: translationGroups.Labels + "ClientCeoDocument",
    ClientCeoAdrress: translationGroups.Labels + "ClientCeoAdrress",
    ClientCeoCity: translationGroups.Labels + "ClientCeoCity",
    ClientCeoStreet: translationGroups.Labels + "ClientCeoStreet",
    ClientCeoHouse: translationGroups.Labels + "ClientCeoHouse",
    ClientCeoFlat: translationGroups.Labels + "ClientCeoFlat",
    ClientCeoPhone: translationGroups.Labels + "ClientCeoPhone",
    CeoActDoc: translationGroups.Labels + "CeoActDoc",
    ActDoc: translationGroups.Labels + "ActDoc",
    ClientRepDocIssuePlace: translationGroups.Labels + "ClientRepDocIssuePlace",
    ClientRepDocIssueDate: translationGroups.Labels + "ClientRepDocIssueDate",
    ClientRepDocValidDate: translationGroups.Labels + "ClientRepDocValidDate",
    ClientRepMandatNo: translationGroups.Labels + "ClientRepMandatNo",
    ClientRepCountry: translationGroups.Labels + "ClientRepCountry",
    ClientRepCity: translationGroups.Labels + "ClientRepCity",
    ClientRepStreet: translationGroups.Labels + "ClientRepStreet",
    ClientRepHouse: translationGroups.Labels + "ClientRepHouse",
    ClientRepFlat: translationGroups.Labels + "ClientRepFlat",
    TradeSecur: translationGroups.Labels + "TradeSecur",
    ClientBenefId: translationGroups.Labels + "ClientBenefId",
    ClientBenefEmail: translationGroups.Labels + "ClientBenefEmail",
    ClientBenefPhoneNo: translationGroups.Labels + "ClientBenefPhoneNo",
    BeneficiaryFunds: translationGroups.Labels + "BeneficiaryFunds",
    OtherInformation: translationGroups.Labels + "OtherInformation",
    MainCustom: translationGroups.Labels + "MainCustom",
    CustomerName: translationGroups.Labels + "CustomerName",
    CustomerActivity: translationGroups.Labels + "CustomerActivity",
    ClientBusPartnerAct: translationGroups.Labels + "ClientBusPartnerAct",
    ClientRepProfile: translationGroups.Labels + "ClientRepProfile",
    ClientCeoRep: translationGroups.Labels + "ClientCeoRep",
    ClientPlanServices: translationGroups.Labels + "ClientPlanServices",
    ClientPlanServicesCard: translationGroups.Labels + "ClientPlanServicesCard",
    ClientPlanServicesTransf: translationGroups.Labels + "ClientPlanServicesTransf",
    ClientPlanServicesCredSb: translationGroups.Labels + "ClientPlanServicesCredSb",
    ClientPlanServicesDep: translationGroups.Labels + "ClientPlanServicesDep",
    ClientPlanServicesEb: translationGroups.Labels + "ClientPlanServicesEb",
    CompanyFunds: translationGroups.Labels + "CompanyFunds",
    CompanyFundsShareholderCap: translationGroups.Labels + "CompanyFundsShareholderCap",
    CompanyFundsActivityProfit: translationGroups.Labels + "CompanyFundsActivityProfit",
    CompanyFundsSaleProperty: translationGroups.Labels + "CompanyFundsSaleProperty",
    CompanyFundsIncomInvest: translationGroups.Labels + "CompanyFundsIncomInvest",
    CompanyFundsSubsidies: translationGroups.Labels + "CompanyFundsSubsidies",
    CompanyFundsBorroving: translationGroups.Labels + "CompanyFundsBorroving",
    CompanyFundsOther: translationGroups.Labels + "CompanyFundsOther",
    WhoOpenAccount: translationGroups.Labels + "WhoOpenAccount",
    ClientSurname: translationGroups.Labels + "ClientSurname",
    ClientRepAdrress: translationGroups.Labels + "ClientRepAdrress",
    ClientRepDocument: translationGroups.Labels + "ClientRepDocument",
    PoliticallyExposedPerson: translationGroups.Labels + "PoliticallyExposedPerson",
    ClientPoliticOther: translationGroups.Labels + "ClientPoliticOther",
    ClientPoliticsInternOrg: translationGroups.Labels + "ClientPoliticsInternOrg",
    ClientPoliticArmForces: translationGroups.Labels + "ClientPoliticArmForces",
    PepInstitution: translationGroups.Labels + "PepInstitution",
    ClientPep_Id: translationGroups.Labels + "ClientPep_Id",
    IsinCode: translationGroups.Labels + "IsinCode",
    CompanyActivity: translationGroups.Labels + "CompanyActivity",
    YearlyIncome: translationGroups.Labels + "YearlyIncome",
    IncPaym: translationGroups.Labels + "IncPaym",
    IncRem: translationGroups.Labels + "IncRem",
    IncomFrom: translationGroups.Labels + "IncomFrom",
    SpecifyCustomers: translationGroups.Labels + "SpecifyCustomers",
    OutPaym: translationGroups.Labels + "OutPaym",
    OutRem: translationGroups.Labels + "OutRem",
    FundsSentTo: translationGroups.Labels + "FundsSentTo",
    MainBusPartner: translationGroups.Labels + "MainBusPartner",
    CurrExc: translationGroups.Labels + "CurrExc",
    Loan: translationGroups.Labels + "Loan",
    MoneyInAcc: translationGroups.Labels + "MoneyInAcc",
    LoginPage: translationGroups.Labels + "LoginPage",
    PersonCode: translationGroups.Labels + "PersonCode",
    TokenLive: translationGroups.Labels + "TokenLive",
    AuthType: translationGroups.Labels + "AuthType",
    PhonePrefix: translationGroups.Labels + "PhonePrefix",
    ClientLeiCode: translationGroups.Labels + "ClientLeiCode",
    ClientBenefBirthDate: translationGroups.Labels + "ClientBenefBirthDate",
    ClientBenefIdDoc: translationGroups.Labels + "ClientBenefIdDoc",
    ClientBenefDocNo: translationGroups.Labels + "ClientBenefDocNo",
    ClientCeoBirthDate: translationGroups.Labels + "ClientCeoBirthDate",
    ClientRepBirthDate: translationGroups.Labels + "ClientRepBirthDate",
    DocumentOnSigning: translationGroups.Labels + "DocumentOnSigning",
    ApplicationSigning: translationGroups.Labels + "ApplicationSigning",
    AgreementSigning: translationGroups.Labels + "AgreementSigning",
    OnboardingComplete: translationGroups.Labels + "OnboardingComplete",
    PeriodicReviewComplete: translationGroups.Labels + "PeriodicReviewComplete",
    ClientSecondAddress: translationGroups.Labels + "ClientSecondAddress",
    ClientSameRealAddress: translationGroups.Labels + "ClientSameRealAddress",
    Or: translationGroups.Labels + "Or",
    Confirmation: translationGroups.Labels + "Confirmation",
    PersonalDataProccessing: translationGroups.Labels + "PersonalDataProccessing",
    PlanServices: translationGroups.Labels + "PlanServices",
    ApplicationSubmitted: translationGroups.Labels + "ApplicationSubmitted",
    ApplicationSubmittedMessages: translationGroups.Labels + "ApplicationSubmittedMessages",
    ReviewerComment: translationGroups.Labels + "ReviewerComment",
    CustomerEmpty: translationGroups.Labels + "CustomerEmpty",
    ClientFundsSentCountryEmpty: translationGroups.Labels + "ClientFundsSentCountryEmpty",
    ClientBusPartnerEmpty: translationGroups.Labels + "ClientBusPartnerEmpty",
    OnboardingCompleteLinkName: translationGroups.Labels + "OnboardingCompleteLinkName",
    SelectDate: translationGroups.Labels + "SelectDate",
    Uboretail: translationGroups.Labels + "Uboretail",
    Retail: translationGroups.Labels + "Retail",
    BrandName: translationGroups.Labels + "BrandName",
    CustomerCountry: translationGroups.Labels + "CustomerCountry",
    ClientServicesDescription: translationGroups.Labels + "ClientServicesDescription",
    RequireBusinessLicense: translationGroups.Labels + "RequireBusinessLicense",
    BusinessLicenseNumber: translationGroups.Labels + "BusinessLicenseNumber",
    WhoOpenAccountPerson: translationGroups.Labels + "WhoOpenAccountPerson",
    OtherBenefRegCountSch: translationGroups.Labels + "OtherBenefRegCountSch",
    OtherCeoCitDocTy: translationGroups.Labels + "OtherCeoCitDocTy",
    OtherCeoCitDocNo: translationGroups.Labels + "OtherCeoCitDocNo",
    OtherCeoCitDocCountry: translationGroups.Labels + "OtherCeoCitDocCountry",
    OtherCeoCitizien: translationGroups.Labels + "OtherCeoCitizien",
    OtherCeoCitizienSch: translationGroups.Labels + "OtherCeoCitizienSch",
    OtherClientBenefRegDocType: translationGroups.Labels + "OtherClientBenefRegDocType",
    OtherClientBenefRegCountry: translationGroups.Labels + "OtherClientBenefRegCountry",
    OtherClientBenefRegDocNo: translationGroups.Labels + "OtherClientBenefRegDocNo",
    OtherClientBenefRegDocCountry: translationGroups.Labels + "OtherClientBenefRegDocCountry",
    OtherClientBenefRegCountSch: translationGroups.Labels + "OtherClientBenefRegCountSch",
    AmlRulesLeg: translationGroups.Labels + "AmlRulesLeg",
    AmlProcedure: translationGroups.Labels + "AmlProcedure",
    AmlCheckInSancLis: translationGroups.Labels + "AmlCheckInSancLis",
    AmlOfficer: translationGroups.Labels + "AmlOfficer",
    AmlOfficerEmail: translationGroups.Labels + "AmlOfficerEmail",
    AmlOfficerNameSur: translationGroups.Labels + "AmlOfficerNameSur",
    AmlOfficerPhone: translationGroups.Labels + "AmlOfficerPhone",
    ClientPaymCash: translationGroups.Labels + "ClientPaymCash",
    ClientPaymCryp: translationGroups.Labels + "ClientPaymCryp",
    WhoOpenAccountList: translationGroups.Labels + "WhoOpenAccountList",
    WhoOpenAccountIfNotCEO: translationGroups.Labels + "WhoOpenAccountIfNotCEO",
    CheckModalOk: translationGroups.Labels + "CheckModalOk",
    CheckModalCancel: translationGroups.Labels + "CheckModalCancel",
    CheckModalTitle: translationGroups.Labels + "CheckModalTitle",
    PeriodicReview: translationGroups.Labels + "PeriodicReview",
    Onboarding: translationGroups.Labels + "Onboarding",
    AgreeOnCorrectDocument: translationGroups.Labels + "AgreeOnCorrectDocument"
  },
  Messages: {
    NoData: translationGroups.Messages + "NoData",
    PageDoesntExist: translationGroups.Messages + "PageDoesntExist",
    ApproveKYC: translationGroups.Messages + "ApproveKYC",
    DeleteKYC: translationGroups.Messages + "DeleteKYC",
    ClientBenefecariesNote: translationGroups.Messages + "ClientBenefecariesNote",
    ClientBenefecariesNoteAfter: translationGroups.Messages + "ClientBenefecariesNoteAfter",
    Confirmation: translationGroups.Messages + "Confirmation",
    PersonalDataProccessing: translationGroups.Messages + "PersonalDataProccessing",
    PoliticallyExposedPersonNote: translationGroups.Messages + "PoliticallyExposedPersonNote",
    PreSignFirst: translationGroups.Messages + "PreSignFirst",
    PreSignSeconds: translationGroups.Messages + "PreSignSeconds",
    SignFirst: translationGroups.Messages + "SignFirst",
    SignSecond: translationGroups.Messages + "SignSecond",
    SignTable1: translationGroups.Messages + "SignTable1",
    SignTable2: translationGroups.Messages + "SignTable2",
    SignTable3: translationGroups.Messages + "SignTable3",
    SignTable4: translationGroups.Messages + "SignTable4",
    SignThird: translationGroups.Messages + "SignThird",
    LoginBubble: translationGroups.Messages + "LoginBubble",
    HowOpenCompanyAccount: translationGroups.Messages + "HowOpenCompanyAccount",
    FirstNeedVerifyYourIdentity: translationGroups.Messages + "FirstNeedVerifyYourIdentity",
    SecondLoginProvideDocuments: translationGroups.Messages + "SecondLoginProvideDocuments",
    ClientBenefecariesNoteAfter2: translationGroups.Messages + "ClientBenefecariesNoteAfter2",
    TradeSecur2: translationGroups.Messages + "TradeSecur2"
  },
  MessageTitles: {
    PreSign: translationGroups.Messages + "PreSign",
    Sign: translationGroups.Messages + "Sign"
  },
  ModalTitles: {
    ApproveKYC: translationGroups.ModalTitles + "ApproveKYC",
    DeleteKYC: translationGroups.ModalTitles + "DeleteKYC",
    ChooseCompany: translationGroups.ModalTitles + "ChooseCompany",
    ApproveLogin: translationGroups.ModalTitles + "ApproveLogin",
    RefreshModal: translationGroups.ModalTitles + "YouAreInactiveOnThisPage",
    CurrentSession: translationGroups.ModalTitles + "TheCurrentSessionWillEndIn",
    TitleRefresh: translationGroups.ModalTitles + "DoYouWantToContinue",
    NoAuthorizedCompany: translationGroups.ModalTitles + "NoAuthorizedCompany",
    NoAuthorizedCompanyDescription: translationGroups.ModalTitles + "NoAuthorizedCompanyDescription"
  },
  NotificationMessages: {
    KYCApproveSubmit: translationGroups.NotificationMessages + "KYCApproveSubmit",
    SomethingWentWrong: translationGroups.NotificationTitles + "SomethingWentWrong",
    NotAllStepsFinished: translationGroups.NotificationTitles + "NotAllStepsFinished",
    SuccessOperation: translationGroups.NotificationMessages + "SuccessOperation",
    ShareholdersCantExceed100: translationGroups.NotificationMessages + "ShareholdersCantExceed100",
    TokenNotFound: translationGroups.NotificationMessages + "TokenNotFound"
  },
  NotificationTitles: {
    KycSuccessUpload: translationGroups.NotificationTitles + "KycSuccessUpload",
    KycReviewedSuccessfully: translationGroups.NotificationTitles + "KycReviewedSuccessfully",
    KycSuccessApprove: translationGroups.NotificationTitles + "KycSuccessApprove",
    SuccessOperation: translationGroups.NotificationTitles + "SuccessOperation",
    LoginFailed: translationGroups.NotificationTitles + "LoginFailed"
  },
  Period: {
    Day: translationGroups.Period + "Day",
    Week: translationGroups.Period + "Week",
    Month: translationGroups.Period + "Month",
    Quarter: translationGroups.Period + "Quarter",
    TenLastOperations: translationGroups.Period + "TenLastOperations",
    LastSevenDaysOperations: translationGroups.Period + "LastSevenDaysOperations",
    LastThirtyDaysOperations: translationGroups.Period + "LastThirtyDaysOperations",
    FromBeginningCurrentMonth: translationGroups.Period + "FromBeginningCurrentMonth",
    LastMonth: translationGroups.Period + "LastMonth",
    Days30: translationGroups.Period + "Days30",
    Days60: translationGroups.Period + "Days60",
    Days90: translationGroups.Period + "Days90"
  },
  Validations: {
    CountersRequiredFrom: translationGroups.Validations + "CountersRequiredFrom",
    IncorrectID: translationGroups.Validations + "IncorrectID",
    CountersRequiredTo: translationGroups.Validations + "CountersRequiredTo",
    CountersValuesNotValid: translationGroups.Validations + "CountersValuesNotValid",
    FieldRequired: translationGroups.Validations + "FieldRequired",
    FieldRequiredAndApprove: translationGroups.Validations + "FieldRequiredAndApprove",
    FieldRequiredApproveCode: translationGroups.Validations + "FieldRequiredApproveCode",
    PasswordCantContainSpaces: translationGroups.Validations + "PasswordCantContainSpaces",
    PasswordMustContainUpperLowerNumber:
      translationGroups.Validations + "PasswordMustContainUpperLowerNumber",
    PasswordNotSame: translationGroups.Validations + "PasswordNotSame",
    PasswordTooShort: translationGroups.Validations + "PasswordTooShort",
    InputIsTooLong: translationGroups.Validations + "InputIsTooLong",
    MaxInputIs: translationGroups.Validations + "MaxInputIs",
    MustBeCodeSelected: translationGroups.Validations + "MustBeCodeSelected",
    MustBePurposeSelected: translationGroups.Validations + "MustBePurposeSelected",
    SumToBig: translationGroups.Validations + "SumToBig",
    SameAccountID: translationGroups.Validations + "SameAccountID",
    BadPersonalCode: translationGroups.Validations + "BadPersonalCode",
    BadCompanyCode: translationGroups.Validations + "BadCompanyCode",
    ChatMessageRequired: translationGroups.Validations + "ChatMessageRequired",
    FieldEmail: translationGroups.Validations + "FieldEmail",
    identificationCodeValueNotValid:
      translationGroups.Validations + "identificationCodeValueNotValid",
    FieldsRequired: translationGroups.Validations + "FieldsRequired",
    FieldPhoneNumber: translationGroups.Validations + "FieldPhoneNumber",
    FieldPhonePrefix: translationGroups.Validations + "FieldPhonePrefix",
    InputIsTooShort: translationGroups.Validations + "InputIsTooShort",
    MinInputIs: translationGroups.Validations + "MinInputIs",
    AllFieldsRequired: translationGroups.Validations + "AllFieldsRequired",
    PasswordTooLong: translationGroups.Validations + "PasswordTooLong",
    IsntNumeric: translationGroups.Validations + "IsntNumeric",
    NumberTooBig: translationGroups.Validations + "NumberTooBig",
    NumberTooSmall: translationGroups.Validations + "NumberTooSmall",
    CanntbeNumeric: translationGroups.Validations + "CanntbeNumeric",
    ClientBenefShareTooSmall: translationGroups.Validations + "ClientBenefShareTooSmall"
  },
  Menus: {
    AllApplications: translationGroups.Menus + "AllApplications",
    NewKyc: translationGroups.Menus + "NewKyc",
    Login: translationGroups.Menus + "Login"
  },
  PrintLabels: {
    LegalForm: translationGroups.PrintLabels + "LegalForm",
    WWWAdress: translationGroups.PrintLabels + "WWWAdress",
    ClientTaxPayerId: translationGroups.PrintLabels + "ClientTaxPayerId",
    AccountOpeningReason: translationGroups.PrintLabels + "AccountOpeningReason",
    Questionnaire: translationGroups.PrintLabels + "Questionnaire",
    CeoInfo: translationGroups.PrintLabels + "CeoInfo",
    PoliticallyVulnerablePersons: translationGroups.PrintLabels + "PoliticallyVulnerablePersons",
    Ceo: translationGroups.PrintLabels + "Ceo",
    ClientCodeOrBirthday: translationGroups.PrintLabels + "ClientCodeOrBirthday",
    DocumentType: translationGroups.PrintLabels + "DocumentType",
    ValidTill: translationGroups.PrintLabels + "ValidTill",
    ParlamentMember: translationGroups.PrintLabels + "ParlamentMember",
    SpecifyPersonPosition: translationGroups.PrintLabels + "SpecifyPersonPosition",
    Myself: translationGroups.PrintLabels + "Myself",
    CloseFamilyMember: translationGroups.PrintLabels + "CloseFamilyMember",
    BeneficiariesLegalEntity: translationGroups.PrintLabels + "BeneficiariesLegalEntity",
    ShareholderBeneficialOwner: translationGroups.PrintLabels + "ShareholderBeneficialOwner",
    Deposits: translationGroups.PrintLabels + "Deposits",
    CurrencyTrading: translationGroups.PrintLabels + "CurrencyTrading",
    MainActivityCode: translationGroups.PrintLabels + "MainActivityCode",
    MainCustom: translationGroups.PrintLabels + "MainCustom",
    ClientNo: translationGroups.PrintLabels + "ClientNo",
    MainBusPartner: translationGroups.PrintLabels + "MainBusPartner",
    DateAndSignature: translationGroups.PrintLabels + "DateAndSignature",
    EmployeeInfoWhoAcceptedQuestionnaire:
      translationGroups.PrintLabels + "EmployeeInfoWhoAcceptedQuestionnaire",
    ClientSignatureAndDate: translationGroups.PrintLabels + "ClientSignatureAndDate",
    ClientTaxPayerIdInfoMessage: translationGroups.PrintLabels + "ClientTaxPayerIdInfoMessage",
    PdfTitleInfoMessage: translationGroups.PrintLabels + "PdfTitleInfoMessage",
    BankServicesAndProductsYouPlanToUse:
      translationGroups.PrintLabels + "BankServicesAndProductsYouPlanToUse",
    TypeOfAccount: translationGroups.PrintLabels + "TypeOfAccount",
    AtRepresentativeActingAccordingToPowerOfAttorney:
      translationGroups.PrintLabels + "AtRepresentativeActingAccordingToPowerOfAttorney",
    EmployeeOfCompany: translationGroups.PrintLabels + "EmployeeOfCompany",
    PersonProvidingFinancialAccounting:
      translationGroups.PrintLabels + "PersonProvidingFinancialAccounting",
    AttachPassportIDPermit: translationGroups.PrintLabels + "AttachPassportIDPermit",
    YesClientPoliticsMember: translationGroups.PrintLabels + "YesClientPoliticsMember",
    Operations: translationGroups.PrintLabels + "Operations",
    Income: translationGroups.PrintLabels + "Income",
    ClientNameCountry: translationGroups.PrintLabels + "ClientNameCountry",
    ActivityNo: translationGroups.PrintLabels + "ActivityNo",
    YesPleaseSpecify: translationGroups.PrintLabels + "YesPleaseSpecify",
    PlannedTurnoverEURPerMonth: translationGroups.PrintLabels + "PlannedTurnoverEURPerMonth",
    SpecifyMainSuppliersTheirCountriesAndAreasOfActivity:
      translationGroups.PrintLabels + "SpecifyMainSuppliersTheirCountriesAndAreasOfActivity",
    Expenses: translationGroups.PrintLabels + "Expenses",
    FillAtLeastThreeCountriesWithHighestPlannedExpenses:
      translationGroups.PrintLabels + "FillAtLeastThreeCountriesWithHighestPlannedExpenses",
    SupplierNo: translationGroups.PrintLabels + "SupplierNo",
    ClientSignature: translationGroups.PrintLabels + "ClientSignature",
    AgreeReceivePromotionalNoticesFromBank:
      translationGroups.PrintLabels + "AgreeReceivePromotionalNoticesFromBank",
    SignatureDirectorOrAuthorizedPersonDate:
      translationGroups.PrintLabels + "SignatureDirectorOrAuthorizedPersonDate",
    NameLastNameSignatureThatAcceptedQuestionnaire:
      translationGroups.PrintLabels + "NameLastNameSignatureThatAcceptedQuestionnaire"
  },
  WhoOpenAccount: {
    CEO: translationGroups.WhoOpenAccount + "CEO",
    REP: translationGroups.WhoOpenAccount + "REP"
  }
};
